const showMarkets = (event) => {
  const target = event.target
  const container = target.closest(".market-selector")
  container.classList.toggle("is-active")
}

let currentCartItems = []

const toggleClassEl = (selector, className) => {
  const el = document.querySelector(selector)
  el.classList.toggle(className)
}

document.addEventListener("DOMContentLoaded", function () {
  const script = document.createElement("script")
  script.src = "//www.klaviyo.com/media/js/public/klaviyo_subscribe.js"
  script.type = "text/javascript"
  document.body.appendChild(script)

  setTimeout(() => {
    try {
      KlaviyoSubscribe.attachToForms("#newsletter-footer", {
        hide_form_on_success: true,
        custom_success_message: true,
        success_message: "Thanks for subscribe!!",
        extra_properties: {
          $source: "webfooter",
        },
      })
    } catch (e) {
      console.error(e)
    }
  }, 1000)
})

const numberToPrice = (num) => {
  if (num === 0) return 0

  num = num.toString()

  let dollars = num.substring(0, num.length - 2)
  let cents = num.substr(-2)
  let price = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + cents

  return price
}

function formatNumber(num) {
  num = num.toString()
  let dollars = num.substring(0, num.length - 2)
  let cents = num.substr(-2)
  return dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + cents
}

document.addEventListener("DOMContentLoaded", () => {
  function okeStarsFilters() {
    const okeReviews = document.querySelector(".oke-w-reviews-head")
    const okeRating = document.querySelectorAll(
      ".oke-w-breakdownModule-distribution-label"
    )
    okeRating.forEach((el) => {
      el.addEventListener("click", () => {
        const ratingNumber = el.querySelector(
          ".oke-w-breakdownModule-distribution-label-number"
        ).innerText
        const inputRating = document.querySelector(
          `input[name='Rating ${ratingNumber}'] + label`
        )
        inputRating.click()
        okeReviews.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start",
        })
      })
    })
  }
  const interval = setInterval(() => {
    if (
      document.querySelectorAll(".oke-w-breakdownModule-distribution-label")
        .length > 6
    ) {
      okeStarsFilters()
      clearInterval(interval)
    }
  }, 500)
  setTimeout(() => {
    clearInterval(interval)
  }, 10000)
})

const btnAddToCart = document.querySelectorAll('.btn_product_form');
const btnAppCart = document.querySelector('#_rsi-buy-now-button-overwrite') || document.querySelector('._rsi-buy-now-button');

if (btnAppCart) {
  btnAddToCart.forEach((btn) => {
    btn.addEventListener('click', async() => {

      try {
        const clearRes = await fetch((window.Shopify?.routes?.root ? window.Shopify.routes.root : '/') + 'cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin'
        });
        if (!clearRes.ok) throw new Error(`We could not clear the cart (status ${clearRes.status})`);
  
        if (btnAppCart) {
          btnAppCart.click();
        }
      } catch (error) {
        console.error('Error en checkProducts:', error);        
      }
    })
  })
}